<template>
  <div class="wp-skeleton">
    <UiSkeleton class="wp-skeleton__pagination" />
    <UiSkeleton class="wp-skeleton__slider" :class="{ 'desktop': $device.isDesktop }" :items="$device.isDesktop ? 5 : 3" />
    <UiSkeleton class="wp-skeleton__card" :items="3" />
  </div>
</template>
<script>
export default {
  name: 'RegistrationBonusSkeleton',
}
</script>
<style lang="scss" scoped>
  .wp-skeleton {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    &__pagination {
      width: 120px !important;
      height: 20px;
      margin-bottom: 48px;
    }
    &__slider {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 100vw;
      overflow: hidden;
      
      &:not(.desktop) {
        gap: 20px;
        ::v-deep.skeleton__item {
          flex-shrink: 0;
          height: 120px;
          width: 120px;
          
          &:nth-child(2){
            height: 240px;
            width: 240px;
          }
        }
      }
      
      &.desktop {
        gap: 40px;
        ::v-deep.skeleton__item {
          flex-shrink: 0;
          height: 182px;
          width: 182px;

          &:nth-child(3){
            height: 290px;
            width: 290px;
          }
        }
      }
    }
    &__card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      margin-top: 72px;
      
      ::v-deep.skeleton__item {
        height: 20px;
        width: 140px;
        
        &:first-child {
          height: 32px;
          width: 280px;
        }
        &:last-child {
          margin-top: 32px;
          height: 56px;
          width: 100%;
        }
      }
    }
  }
</style>
